export default __webpack_public_path__ + "static/media/location_preview_mesozoic_mayhem.d59c5f75.svg";